
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

function MyMessages() {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  useEffect(() => {
    const getConversations = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          "/api/messages",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.message ||
              "Չհաջողվեց ստանալ հաղորդագրությունները"
          );
        }

        setConversations(data);
      } catch (error) {
        console.error(
          "GET CONVERSATIONS ERROR:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    getConversations();
  }, [token]);

  if (!token) {
    return (
      <>
        <Header />

        <main className="container messages-page">
          <h1>Մուտք գործեք</h1>

          <p>
            Հաղորդագրությունները տեսնելու համար
            անհրաժեշտ է մուտք գործել։
          </p>

          <Link to="/login">
            Մուտք գործել
          </Link>
        </main>

        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <main className="messages-page">
        <div className="container">

          <div className="messages-header">
            <Link to="/products">
              ← Հայտարարություններ
            </Link>

            <h1>
              💬 Իմ հաղորդագրությունները
            </h1>
          </div>

          {loading ? (
            <div className="messages-loading">
              Հաղորդագրությունները բեռնվում են...
            </div>
          ) : conversations.length === 0 ? (
            <div className="no-messages">
              <h2>
                Դեռ զրույցներ չկան
              </h2>

              <p>
                Երբ որևէ օգտատիրոջ հետ հաղորդագրություն
                փոխանակեք, այստեղ կերևա զրույցը։
              </p>

              <Link to="/products">
                Դիտել հայտարարությունները
              </Link>
            </div>
          ) : (
            <div className="conversations-list">

              {conversations.map((conversation) => {
                const user = conversation.user;

                return (
                  <Link
                    key={user._id}
                    to={`/messages/${user._id}`}
                    className="conversation-item"
                  >
                    <div className="conversation-avatar">
                      {user.photo ? (
                        <img
                          src={user.photo}
                          alt={
                            user.name ||
                            user.username ||
                            "User"
                          }
                        />
                      ) : (
                        <span>
                          👤
                        </span>
                      )}
                    </div>

                    <div className="conversation-info">
                      <h3>
                        {user.name ||
                          user.username ||
                          "Օգտատեր"}
                      </h3>

                      <p>
                        {conversation.lastMessage}
                      </p>

                      <small>
                        {new Date(
                          conversation.createdAt
                        ).toLocaleString("hy-AM")}
                      </small>
                    </div>

                    <div className="conversation-arrow">
                      →
                    </div>
                  </Link>
                );
              })}

            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}

export default MyMessages;

